module.exports = __webpack_public_path__ + "static/media/d21kz.f31ce594.pdf";